module.exports = __webpack_public_path__ + "media/img/new-assets/promo-badge-803ab3465139fe77b6247c9f34fef86b.png";